import { render, staticRenderFns } from "./DepartmentEditDialog.vue?vue&type=template&id=a0c8e8ec&scoped=true"
import script from "./DepartmentEditDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DepartmentEditDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DepartmentEditDialog.vue?vue&type=style&index=0&id=a0c8e8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c8e8ec",
  null
  
)

export default component.exports